var map = {
	"./applepay.png": 29596,
	"./kakaopay.png": 59917,
	"./lpay.png": 17960,
	"./npay.png": 52942,
	"./payco.png": 33692,
	"./samsungpay.png": 26636,
	"./skpay.png": 93444,
	"./tosspay.png": 88229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96984;